<script>
import { getTransactionReportSearchTools } from '@/graphql/accounting/reports/getTransactionReport.graphql';
import { QueryMixin } from '@/components/Core/Helpers';

export default {
  mixins: [QueryMixin],
  query() {
    return {
      query: getTransactionReportSearchTools,
      variables: {
        supplier_id: this.$store.getters['auth/supplierId']
      }
    };
  }
};
</script>
